import { SchemaResponse, unAuth } from "@/modules/api/axios"
import { PagingSchema } from "@/modules/types"
import { Blog } from "@/modules/types/others/blog"

type FetchBlog = {
  page: number
  take: number
  search?: string
}
export const getAllBlogs = (params: FetchBlog) => {
  return unAuth.get<SchemaResponse<PagingSchema<Blog>>>(`blog/list`, {
    params: {
      ...params,
      order: "DESC",
      sortBy: "createdAt"
    }
  })
}
